import { Box, Button, Skeleton, styled, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getStories } from '../asiosConfig';
import Story from './Story';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import storyImg1 from "../images/storyImg1.png";
import { toast } from 'react-toastify';
import Footer from './Footer';
import Nav from './Nav';
import { StoryBox } from './StoryBox';

const StoryWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2, 0),
}));
const StoryContent = styled(Typography)(({ theme }) => ({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    textOverflow: 'ellipsis',
}))
export const SuccessStories = () => {

    const [story, setStory] = useState([]);
    const [expandedStoryIndex, setExpandedStoryIndex] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const response = await getStories();
                if (response.status === 200 || response.status === 201) {
                    setStory(response.data.data);
                } else {
                    toast.error('Failed to fetch stories');
                }
            } catch (error) {
                toast.error(error.response.data.message);
            } finally {
                setLoading(false);
            }
        };
        fetchStories();
    }, []);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', options); // format as "13 July 2024"
    };
    return (
        <Box>
            <Nav />
            <Box mt={12} mb={5}>
                <section className="mt-5 ">
                    <div className="container">
                        <div className="storyTitle text-center">
                            {loading ? (
                                <>
                                    <Skeleton variant="text" width="40%" height={40} sx={{ mx: 'auto', mb: 2 }} />
                                    <Skeleton variant="text" width="60%" height={30} sx={{ mx: 'auto', mb: 1 }} />
                                    <Skeleton variant="text" width="60%" height={30} sx={{ mx: 'auto', mb: 1 }} />
                                    <Skeleton variant="text" width="60%" height={30} sx={{ mx: 'auto', mb: 1 }} />
                                </>
                            ) : (
                                <><Typography
                                    variant="h4"
                                    // component="h3"
                                    gutterBottom
                                    sx={{ fontFamily: "Montserrat" }}
                                >IND Matrimony Success Story
                                </Typography>
                                    <p>
                                        At IND Matrimony we believe every match is a success worth celebrating. Many couples have begun their beautiful journeys through our platform, and we wish them a lifetime of love and happiness. If you found your perfect match here, we’d love to share your joy! Send us your wedding or engagement photograph, and your story could be featured in our exclusive “Success Stories” section.
                                    </p>
                                </>
                            )}
                        </div>
                        <StoryWrapper>
                            <div className="row justify-content-center align-items-center mt-4">
                                {loading
                                    ? Array.from(new Array(4)).map((_, index) => (
                                        <div key={index} className="col-lg-3 col-md-6">
                                            <Skeleton variant="rectangular" width="100%" height={200} sx={{ mb: 2 }} />
                                            <Skeleton variant="text" width="80%" height={20} sx={{ mx: 'auto' }} />
                                            <Skeleton variant="text" width="70%" height={20} sx={{ mx: 'auto', mb: 1 }} />
                                        </div>
                                    ))
                                    : story.length === 0 ? (
                                        <div className="col-lg-3 col-md-6">
                                            <p>No Story Found</p>
                                        </div>
                                    ) : (
                                        story.map((item, index) => (
                                            <div key={index} className="col-lg-3 col-md-6">
                                                <StoryBox
                                                    image={item.images}
                                                    bride={item.bride}
                                                    groom={item.groom}
                                                    story={item.story}
                                                    date={formatDate(item.marriage_date)}
                                                />
                                            </div>
                                        ))
                                    )}
                            </div>
                        </StoryWrapper>
                    </div>
                </section>
            </Box>
            <Footer />
        </Box>
    )
}
